import actions from './Actions'
import state from './State'
import getters from './Getters'
import mutations from './Mutations'

export default {
  state,
  actions,
  getters,
  mutations,
}
